<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('sup/pc_banner_sup_login.webp')" alt="Login guide banner for PC">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />
        <h1 class="main-title">
          ログイン方法
        </h1>

        <div class="tab-frame">
          <ul class="tab-list how-to-tab">
            <li class="tab-list-item" :class="{'is-btn-active': activeIndex === 0}" @click="setActiveIndex(0)">
              アカウントを使用-PC版
            </li>
            <li class="tab-list-item" :class="{'is-btn-active': activeIndex === 1}" @click="setActiveIndex(1)">
              携帯電話を使用-PC版
            </li>
            <li class="tab-list-item" :class="{'is-btn-active':activeIndex === 2}" @click="setActiveIndex(2)">
              アカウントを使用-モバイル版
            </li>
            <li class="tab-list-item" :class="{'is-btn-active': activeIndex === 3}" @click="setActiveIndex(3)">
              携帯電話を使用-モバイル版
            </li>
          </ul>

          <div class="tab-contents-wrap">
            <!-- アカウントを使用-PC版 -->
            <div class="tab-contents" :class="{ 'is-contents-active': activeIndex === 0 }">
              <h2 class="main-title">
                ステップ 1
              </h2>
              <h3 class="subheading fs_6">
                ホーム画面の「ログイン」をクリック
              </h3>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/login_tab01_01.png')" alt="User clicking the login button on the home screen">
              </div>

              <h2 class="main-title">
                ステップ 2
              </h2>
              <h3 class="subheading fs_6">
                ログイン方法の「アカウント」を選択
              </h3>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/login_tab01_02.png')" alt="User selecting 'Account' as the login method">
              </div>

              <h2 class="main-title">
                ステップ 3
              </h2>
              <h3 class="subheading fs_6">
                空欄に必要事項を入力
              </h3>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/login_tab01_03.png')" alt="User entering required information in the fields">
              </div>
              <h4 class="subheading fs_6">
                ※パスワードをお忘れの場合
              </h4>
              <p class="subheading fs_6">
                万が一パスワードを忘れた場合、<br>「パスワードをお忘れの場合」をクリックし、<br>必要事項を記入し、「送信する」をクリックしてください。
              </p>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/login_tab01_04.png')" alt="User clicking on 'Forgot Password' link">
              </div>

              <h2 class="main-title">
                ステップ 4
              </h2>
              <h3 class="subheading fs_6">
                ログイン」をクリック
              </h3>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/login_tab01_05.png')" alt="User clicking the login button">
              </div>
            </div>
            <!-- アカウントを使用-PC版 tab-contents End -->

            <!-- 携帯電話を使用-PC版 -->
            <div class="tab-contents" :class="{ 'is-contents-active': activeIndex === 1 }">
              <h2 class="main-title">
                ステップ 1
              </h2>
              <h3 class="subheading fs_6">
                ホーム画面の「ログイン」をクリック
              </h3>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/login_tab01_01.png')" alt="">
              </div>

              <h2 class="main-title">
                ステップ 2
              </h2>
              <h3 class="subheading fs_6">
                ログイン方法の「携帯番号」を選択
              </h3>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/login_tab02_02.png')" alt="">
              </div>

              <h2 class="main-title">
                ステップ 3
              </h2>
              <h3 class="subheading fs_6">
                空欄に必要事項を入力
              </h3>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/login_tab02_03.png')" alt="">
              </div>
              <h2 class="subheading fs_6">
                ※パスワードをお忘れの場合 <br>
                <br>
                万が一パスワードを忘れた場合、<br>
                「パスワードをお忘れの場合」をクリックし、<br>
                必要事項を記入し、「送信する」をクリックしてください。
              </h2>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/login_tab02_04.png')" alt="">
              </div>

              <h2 class="main-title">
                ステップ 4
              </h2>
              <h3 class="subheading fs_6">
                「ログイン」をクリック
              </h3>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/login_tab02_05.png')" alt="">
              </div>
            </div>
            <!-- 携帯電話を使用-PC版 tab-contents End -->

            <!-- アカウントを使用-モバイル版 -->
            <div class="tab-contents" :class="{ 'is-contents-active': activeIndex === 2 }">
              <h2 class="main-title">
                ステップ 1
              </h2>
              <h3 class="subheading fs_6">
                「ログイン」をタップ
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/login_tab03_01.png')" alt="">
              </div>

              <h2 class="main-title">
                ステップ 2
              </h2>
              <h3 class="subheading fs_6">
                ログイン方法の「アカウント」を選択
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/login_tab03_02.png')" alt="">
              </div>

              <h2 class="main-title">
                ステップ 3
              </h2>
              <h3 class="subheading fs_6">
                空欄に必要事項を入力
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/login_tab03_03.png')" alt="">
              </div>
              <h2 class="subheading fs_6">
                ※パスワードをお忘れの場合 <br>
                <br>
                万が一パスワードを忘れた場合、<br>
                「パスワードをお忘れの場合」をクリックし、<br>
                必要事項を記入し、「送信する」をクリックしてください。
              </h2>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/login_tab03_04.png')" alt="">
              </div>

              <h2 class="main-title">
                ステップ 4
              </h2>
              <h3 class="subheading fs_6">
                「ログイン」をタップ
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/login_tab03_05.png')" alt="">
              </div>
            </div>
            <!-- アカウントを使用-モバイル版 tab-contents End -->

            <!-- 携帯電話を使用-モバイル版 -->
            <div class="tab-contents" :class="{ 'is-contents-active': activeIndex === 3 }">
              <h2 class="main-title">
                ステップ 1
              </h2>
              <h3 class="subheading fs_6">
                「ログイン」をタップ
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/login_tab03_01.png')" alt="">
              </div>

              <h2 class="main-title">
                ステップ 2
              </h2>
              <h3 class="subheading fs_6">
                ログイン方法の「携帯番号」を選択
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/login_tab04_02.png')" alt="">
              </div>

              <h2 class="main-title">
                ステップ 3
              </h2>
              <h3 class="subheading fs_6">
                空欄に必要事項を入力
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/login_tab04_03.png')" alt="">
              </div>
              <h2 class="subheading fs_6">
                ※パスワードをお忘れの場合 <br>
                <br>
                万が一パスワードを忘れた場合、<br>
                「パスワードをお忘れの場合」をクリックし、<br>
                必要事項を記入し、「送信する」をクリックしてください。
              </h2>
              <div class="img-style-bor-sha">
                <img :src="$getThemeImagePath('sup/login_tab04_04.png')" alt="">
              </div>

              <h2 class="main-title">
                ステップ 4
              </h2>
              <h3 class="subheading fs_6">
                「ログイン」をタップ
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="$getThemeImagePath('sup/login_tab04_05.png')" alt="">
              </div>
              <!-- 携帯電話を使用-モバイル版 tab-contents End -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {
      activeIndex: 0
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.app.metaInfo.title,
      meta: [
        {
          vmid: 'login',
          name: 'keywords',
          content: this.$store.state.app.metaInfo.keywords
        }, {
          name: 'description',
          content: this.$store.state.app.metaInfo.description
        }
      ]
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    setActiveIndex(index) {
      this.activeIndex = index
    }
  }
}
</script>
